<template>
  <div class="bg-white p-3">
    <div>
      <div class="d-flex flex-wrap mb-3">
        <div class="m-2 flex-grow-1">
          <label>{{ trans('event.assessment_configs.assessment') }}</label>
          <input
            :value="event.name"
            class="form-control"
            disabled
          >
        </div>
        <div class="m-2 flex-grow-1">
          <label>{{ trans('event.assessment_configs.date') }}</label>
          <input
            :value="moment(event.starttime).format('DD-MM-YYYY')"
            class="form-control"
            disabled
          >
        </div>
        <div class="m-2 flex-grow-1">
          <label> {{ trans('event.assessment_configs.timeslot') }}</label>
          <input
            :value="moment(event.starttime).format('HH:mm') + ' - '+ moment(event.endtime).format('HH:mm') "
            class="form-control"
            disabled
          >
        </div>
        <div class="m-2 flex-grow-1">
          <label>{{ trans('event.assessment_configs.registered_students') }}</label>
          <input
            :value="event.students.length"
            class="form-control"
            disabled
          >
        </div>
      </div>
      <div class="d-flex">
        <AssessmentConfigGridView
          class="grid"
          :parent-event="event"
          :events="events"
        />
        <AssessmentConfigStudentAreaView
          :event-id="eventId"
        />
      </div>
      <div class="d-flex flex-row-reverse">
        <button
          v-tooltip="tooltipText"
          type="button"
          class="btn btn-primary mt-3 students"
          :disabled="students.length > 0 || isLoadingFinalize"
          @click="edit()"
        >
          {{ trans('event.assessment_configs.finalize') }}
        </button>
        <Loader v-if="isLoadingFinalize" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loader from '@/employees/components/Loader'
import AssessmentConfigGridView from '@/employees/components/AssessmentConfig/view/AssessmentConfigGridView'
import AssessmentConfigStudentAreaView from '@/employees/components/AssessmentConfig/view/AssessmentConfigStudentAreaView'
import Modal from '@/employees/AttendanceList/components/Modal'
export default {
  name: 'AssessmentConfigCreateStepTwoView',
  components: {
    Loader,
    AssessmentConfigGridView,
    AssessmentConfigStudentAreaView,
    Modal,
  },
  props: {
    eventId: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      isLoadingFinalize: false,
    }
  },
  computed: {
    ...mapState({
      event (state) {
        return state.events.events[this.eventId]
      },
      events (state) {
        return this.event.childEvents ? this.event.childEvents.map(eventId => state.events.events[eventId]) : []
      },
      assessmentConfig (state) {
        return state.events.assessment_configs[this.event.assessmentConfig]
      },
      students (state) {
        return this.event.students
          ? this.event.students.filter(studentId => !this.eventStudents.includes(studentId)).map(studentId => state.students.students[studentId])
          : []
      },
    }),
    eventStudents () {
      return this.events.map(event => event.students).flat()
    },
    tooltipText() {
      return this.students.length > 0 ? Lang.get('event.assessment_configs.finalize_only_possible_when_all_students_have_a_timeslot') : ''
    }
  },
  methods: {
    edit () {
      this.isLoadingFinalize = true
      this.$store.dispatch('finalizeEventAssessmentConfig', {
        assessmentConfigId: this.assessmentConfig.id,
        data: {
          ...this.assessmentConfig,
        },
      })
        .catch(error => this.extractErrors(error))
        .then(() => { window.location.href = this.event.link })
        .finally(() => { this.isLoadingFinalize = false })
    },
  },
}
</script>

<style scoped lang="scss">
.grid {
  flex-basis: 80%;
  border-width: 1px;
  border-color: darkgray;
  border-style: solid;
  background:  #EEEEEE;
}
.students {
  flex-basis: 20%;
}
.add-event {
  height: 34px;
}

.btn-primary {
  background-color: #25167a !important;
}
</style>
